import React, { Fragment } from 'react'
import styled, { css } from 'styled-components'
import FICBaseButton from './FICBaseButton'
import FICIcon, { LightIcon, RegularIcon } from '../../../common/components-v2/FICIcon/FICIcon'
import PropTypes from 'prop-types'
import FICColors from '../../../common/styles/FICColors'

/**
 * Renderizza un bottone.
 * Può avere sia href che onClick
 * Supporta isLoading con spinner
 * Può avere due icone (destra, sinistra) o una sola centrale ma senza testo, con larghezza minima fissa
 * Può avere solo un'icona, senza testo e di larghezza auto (un quadrato)
 *
 * @param props
 * @returns {*}
 * @constructor
 */
function FICButtonImpl (props) {
  return <FICBaseButton {...props}
    renderButton={renderButton}
  />
}

function renderButton ({ text, isLoading, iconLeft, iconRight, icon }) {
  let iconElement = null
  let iconLeftElement = null
  let iconRightElement = null

  if (isLoading) {
    iconElement = <RegularIcon name='circle-notch fa-spin' style={{ marginRight: text ? 3 : 0 }} />
  } else if (iconLeft) {
    iconLeftElement = <FICIcon name={iconLeft} style={{ marginRight: text ? 4 : 0 }} />
  } else if (iconRight) {
    iconRightElement = <FICIcon name={iconRight} style={{ marginLeft: text ? 4 : 0 }} />
  } else if (icon) {
    iconElement = <FICIcon name={icon} />
  }

  return (
    <Fragment>
      {iconLeftElement}
      {iconElement}
      {!isLoading &&
      text
      }
      {iconRightElement}
    </Fragment>
  )
}

function getColorRoot (secondary) {
  return secondary ? FICColors.button.secondary : FICColors.button.primary
}

const defaultColor = FICColors.button.primary.blue

const FICButton = styled(FICButtonImpl)`
  display: inline-block;
  background-color: ${props => props.color ? getColorRoot(props.useSecondaryColor)[ props.color ].normal : defaultColor.normal};
  color: ${props => props.color ? getColorRoot(props.useSecondaryColor)[ props.color ].text : defaultColor.text};
  border: 1px solid rgba(51, 51, 51, 0.16);
  border-radius: 4px;
  box-shadow: 0 1px 2px 0 rgba(51, 51, 51, 0.08);
  min-width: 105px;
  width: auto;
  height: 32px;
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  text-align: center;
  padding:4px 30px;
  box-sizing: border-box;
  cursor: pointer;
  text-decoration: none;
  ${props => !props.isLoading && css`
    &:hover {
      color: ${props => props.color ? getColorRoot(props.useSecondaryColor)[ props.color ].textHover : FICColors.white};
      text-decoration: none;
      ${props => !props.isDisabled && css`
        background-color: ${props => props.color ? getColorRoot(props.useSecondaryColor)[ props.color ].hover : defaultColor.hover};
      `}
    }
    &:active{
      background-color: ${props => props.color ? getColorRoot(props.useSecondaryColor)[ props.color ].active : defaultColor.active};
    }
    &:focus{
      text-decoration: none;
    }
  `}
  .fa, .icon{
    font-size: 0.8em;
    color: ${props => props.color ? getColorRoot(props.useSecondaryColor)[ props.color ].text : defaultColor.text};
  }
  ${props => props.size === 'small' && css`
    min-width: 91px;
  `}
  ${props => props.size === 'large' && css`
      min-width: 111px;
      height: 40px;
      line-height: 30px;
  `}
  ${props => props.isDisabled && css`
    opacity: 0.6;
    cursor: not-allowed;
    background-color: ${props => props.color ? getColorRoot(props.useSecondaryColor)[ props.color ].disabled : defaultColor.disabled};
    border-color: ${props => props.color ? getColorRoot(props.useSecondaryColor)[ props.color ].disabled : defaultColor.disabled};
    &:hover,
    &:active{
      background-color: ${props => props.color ? getColorRoot(props.useSecondaryColor)[ props.color ].disabled : defaultColor.disabled};
    }
    &:focus{
      color: ${props => props.color ? getColorRoot(props.useSecondaryColor)[ props.color ].text : defaultColor.text};
    }
  `}
  ${props => props.text === undefined && css`
    min-width: unset;
    line-height: unset;
    height: auto;
  `}
  ${props => props.isLoading && css`
    cursor:not-allowed;
  `}
`

FICButtonImpl.propTypes = FICButton.propTypes = {
  color: PropTypes.string,
  /* colore del bottone */
  useSecondaryColor: PropTypes.bool,
  size: PropTypes.oneOf([ 'medium', 'large' ]),
  reactRouterLink: PropTypes.bool,
  icon: PropTypes.oneOfType([ PropTypes.string, PropTypes.array ]),
  iconLeft: PropTypes.oneOfType([ PropTypes.string, PropTypes.array ]),
  iconRight: PropTypes.oneOfType([ PropTypes.string, PropTypes.array ]),
  text: PropTypes.oneOfType([ PropTypes.string, PropTypes.object ]),
  style: PropTypes.object,
  isLoading: PropTypes.bool,
  isDisabled: PropTypes.bool,
  onClick: PropTypes.func
}

FICButtonImpl.defaultProps = FICButton.defaultProps = renderButton.defaultProps = {
  ...FICBaseButton.defaultProps,
  ...{
    color: undefined,
    useSecondaryColor: false,
    size: 'medium',
    icon: undefined,
    iconLeft: undefined,
    iconRight: undefined,
    text: undefined,
    reactRouterLink: false,
    style: undefined,
    isLoading: undefined,
    onClick: undefined
  }
}

renderButton.propTypes = {
  text: PropTypes.string,
  isLoading: PropTypes.bool,
  iconLeft: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  iconRight: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
}

renderButton.defaultProps = {
  text: undefined,
  isLoading: false,
  iconLeft: undefined,
  iconRight: undefined,
  icon: undefined
}

export default FICButton



// WEBPACK FOOTER //
// ./src/common/components-v2/FICButton/FICButton.js